import { createSvgIcon } from '@material-ui/core';

const SvgGlobalIncognito = (props) => (
	<svg width={12} height={12} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		{/* Globe base */}
		<path
			d="M6 1C3.24 1 1 3.24 1 6C1 8.76 3.24 11 6 11C8.76 11 11 8.76 11 6C11 3.24 8.76 1 6 1ZM6 10C3.79 10 2 8.21 2 6C2 3.79 3.79 2 6 2C8.21 2 10 3.79 10 6C10 8.21 8.21 10 6 10Z"
			fill="#92A0AC"
		/>
		{/* Globe meridians */}
		<path d="M6 2V10M2 6H10" stroke="#92A0AC" strokeWidth="0.5" strokeLinecap="round" />
		{/* Incognito mask overlay */}
		<path
			d="M8.5 6.5C7.8 6.5 7.2 6.8 6.8 7.3C6.4 7.1 5.9 7.2 5.6 7.4C5.4 6.8 4.8 6.5 4.1 6.5C3.1 6.5 2.3 7.3 2.3 8.3C2.3 9.3 3.1 10.1 4.1 10.1C4.8 10.1 5.4 9.8 5.6 9.2C5.9 9.4 6.4 9.5 6.8 9.3C7.2 9.8 7.8 10.1 8.5 10.1C9.5 10.1 10.3 9.3 10.3 8.3C10.3 7.3 9.5 6.5 8.5 6.5ZM4.1 9.4C3.6 9.4 3.2 9 3.2 8.3C3.2 7.6 3.6 7.2 4.1 7.2C4.6 7.2 5 7.6 5 8.3C5 9 4.6 9.4 4.1 9.4ZM8.5 9.4C8 9.4 7.6 9 7.6 8.3C7.6 7.6 8 7.2 8.5 7.2C9 7.2 9.4 7.6 9.4 8.3C9.4 9 9 9.4 8.5 9.4Z"
			fill="#92A0AC"
		/>
		{/* Mask strap */}
		<path d="M11.5 4.5H0.5V5.5H11.5V4.5Z" fill="#92A0AC" />
	</svg>
);

const Icon = createSvgIcon(
	<path d="M6 1C3.24 1 1 3.24 1 6C1 8.76 3.24 11 6 11C8.76 11 11 8.76 11 6C11 3.24 8.76 1 6 1ZM6 10C3.79 10 2 8.21 2 6C2 3.79 3.79 2 6 2C8.21 2 10 3.79 10 6C10 8.21 8.21 10 6 10ZM6 2V10M2 6H10M8.5 6.5C7.8 6.5 7.2 6.8 6.8 7.3C6.4 7.1 5.9 7.2 5.6 7.4C5.4 6.8 4.8 6.5 4.1 6.5C3.1 6.5 2.3 7.3 2.3 8.3C2.3 9.3 3.1 10.1 4.1 10.1C4.8 10.1 5.4 9.8 5.6 9.2C5.9 9.4 6.4 9.5 6.8 9.3C7.2 9.8 7.8 10.1 8.5 10.1C9.5 10.1 10.3 9.3 10.3 8.3C10.3 7.3 9.5 6.5 8.5 6.5ZM4.1 9.4C3.6 9.4 3.2 9 3.2 8.3C3.2 7.6 3.6 7.2 4.1 7.2C4.6 7.2 5 7.6 5 8.3C5 9 4.6 9.4 4.1 9.4ZM8.5 9.4C8 9.4 7.6 9 7.6 8.3C7.6 7.6 8 7.2 8.5 7.2C9 7.2 9.4 7.6 9.4 8.3C9.4 9 9 9.4 8.5 9.4ZM11.5 4.5H0.5V5.5H11.5V4.5Z" />,
	'GlobalIncognito'
);

export const GlobalIncognitoIcon = (props) => <Icon {...props} viewBox="-6 -6 24 24" />;

export default SvgGlobalIncognito;
